import * as client from "../../services/client";
import { TYPES } from "../../common/constants";
import { startPRLoading, stopPRLoading } from "./loader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { fetchSuiteCounts } from "./suites";

export const fetchWalkThroughsDone = (payload) => ({
  type: TYPES.FETCH_WALK_THROUGHS_DONE,
  payload,
});

export const onDeleteWalkthroughDone = (payload) => ({
  type: TYPES.DELETE_WALKTHROUGH_DONE,
  payload,
});
export const onClearWalkthroughDone = () => ({
  type: TYPES.CLEAR_WALKTHROUGH_DONE,
});
export const fetchSuiteWalkThroughs =
  (suiteId, roleName, loader) => (dispatch) => {
    if (loader === true) {
      dispatch(startPRLoading());
    }
    return client
      .fetchSuiteWalkThroughs(suiteId, roleName)
      .then((response) => {
        if (response.status === 200 && response.ok) {
          response.json().then((responsejson) => {
            dispatch(stopPRLoading());
            dispatch(fetchWalkThroughsDone(responsejson.data));
          });
        } else {
          dispatch(fetchWalkThroughsDone([]));
          dispatch(stopPRLoading());
          toast.error(" 🚫 Something went wrong, please try again.", {
            autoClose: 3000,
            position: "top-center",
          });
        }
      })
      .catch(() => {
        dispatch(fetchWalkThroughsDone([]));
        dispatch(stopPRLoading());
        toast.error(" 🚫 Something went wrong, please try again.", {
          autoClose: 3000,
          position: "top-center",
        });
      });
  };

export const onWalkthroughScheduled = (params) => {
  return client
    .onWalkthroughScheduled(params)
    .then((response) => {
      if (response.status === 200 || response.ok) {
        response.json().then(() => {
          toast.success("Event Scheduled successfully.", {
            autoClose: 3000,
            position: "top-center",
          });
        });
      } else {
        toast.error("Event Scheduling failed.", {
          autoClose: 3000,
          position: "top-center",
        });
      }
    })
    .catch(() => {
      toast.error(
        " 🚫 Something went wrong while Scheduling event, please try again.",
        { autoClose: 3000, position: "top-center" }
      );
    });
};

export const onDeleteWalkthrough =
  (walkthroughId, userId, suiteId) => (dispatch) => {
    dispatch(startPRLoading());
    return client
      .deleteWalkthrough(walkthroughId, userId)
      .then((response) => {
        dispatch(stopPRLoading());
        if (response.status === 200) {
          response.json().then((responsejson) => {
            if (responsejson.statusCode === 200) {
              dispatch(onDeleteWalkthroughDone(walkthroughId));
              dispatch(fetchSuiteCounts(suiteId));
              toast.success("Walkthrough deleted successfully.", {
                autoClose: 3000,
                position: "top-center",
              });
            } else {
              toast.error("Walkthrough deleting failed.", {
                autoClose: 3000,
                position: "top-center",
              });
            }
          });
        } else {
          toast.error("Walkthrough deleting failed.", {
            autoClose: 3000,
            position: "top-center",
          });
        }
      })
      .catch(() => {
        dispatch(stopPRLoading());
        toast.error(
          " 🚫 Something went wrong while deleting walkthrough, please try again.",
          { autoClose: 3000, position: "top-center" }
        );
      });
  };
